import { useState, useEffect } from "react";
import { Phone } from "lucide-react";
import { BUSINESS } from "@/lib/constants";
import { LogoMark } from "@/components/LogoMark";
import { PhoneChoice } from "@/components/PhoneChoice";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
  { label: "Book", href: "#book", green: true },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-black/85 backdrop-blur-md border-b border-surface-2" : "bg-transparent"
      }`}
    >
      {/* top tagline bar */}
      <div className="w-full bg-ink border-b border-hazard/25" data-testid="top-tagline-bar">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-2 flex items-center justify-center gap-3">
          <span className="w-4 h-4 bg-hazard animate-softpulse shrink-0" />
          <div className="flex flex-col items-center text-center leading-tight">
            <span className="font-mono text-[10px] md:text-sm tracking-[0.22em] text-hazard uppercase">
              {BUSINESS.tagline}
            </span>
            <span className="font-mono text-[9px] md:text-xs tracking-[0.22em] text-hazard/80 uppercase mt-0.5">
              {BUSINESS.area}
            </span>
          </div>
          <span className="w-4 h-4 bg-hazard animate-softpulse shrink-0" />
        </div>
      </div>

      {/* nav row */}
      <div className="max-w-[1400px] mx-auto px-4 md:px-10 py-3 md:h-24 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <a
          href="#top"
          data-testid="logo-link"
          className={`hidden md:block transition-opacity duration-300 ${
            scrolled ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <LogoMark size="md" />
        </a>

        <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 md:gap-6 lg:gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`font-mono text-sm md:text-base lg:text-lg tracking-[0.12em] uppercase transition-colors ${
                l.green
                  ? "text-hazard font-bold hover:text-white"
                  : "text-zinc-200 hover:text-hazard"
              }`}
            >
              {l.label}
            </a>
          ))}
          <PhoneChoice
            testId="nav-call-btn"
            align="right"
            className="flex items-center gap-2 bg-hazard text-black px-4 md:px-6 py-2.5 md:py-3.5 font-mono text-sm md:text-base lg:text-lg tracking-[0.1em] uppercase font-bold hover:bg-white transition-colors"
          >
            <Phone size={16} /> {BUSINESS.phone}
          </PhoneChoice>
        </nav>
      </div>
    </header>
  );
};
